<template>
  <div class="full" id="home">
    <video
      id="fullDis"
      width="1920"
      height="1080"
      class="vdo"
      autoplay
      muted
    ></video>
    <div class="fullbg_top"></div>
    <div class="fullbg_left"></div>
    <div class="fullbg_right"></div>
    <div class="headerbg">
      <div class="headerbar">
        <ul class="menu">
          <li @click="go()" style="margin-left: 50px; width: 119px">
            <div class="ts">环境监测</div>
          </li>
          <li>
            <span>风机系统</span>
          </li>
          <li>
            <span>无烟安装</span>
          </li>
          <li>
            <span>化产系统</span>
          </li>
          <li>
            <span>鼓冷系统</span>
          </li>
          <li>
            <span>气体报警</span>
          </li>
          <li>
            <span>人员定位</span>
          </li>
          <li>
            <span>SIS系统</span>
          </li>
          <li>
            <span>电厂系统</span>
          </li>
        </ul>
        <div class="weather">
          <table>
            <tr>
              <td>
                <span class="time">{{ sysTimes.time }}</span>
              </td>
              <td>
                <div class="week">{{ sysTimes.week }}</div>
                <div class="date">{{ sysTimes.date }}</div>
              </td>
            </tr>
            <tr>
              <td>
                <img
                  src="../assets/images/ta/ta-topWeather.png"
                  align="absmiddle"
                />
                <span class="temp">16&#176;</span>
              </td>
              <td>
                <img
                  src="../assets/images/ta/ta-topWeather.png"
                  align="absmiddle"
                />
                <span class="temp">空气:优</span>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>

    <div class="leftbar"></div>
    <div class="rightbar"></div>
    <div class="leftbox"></div>
    <div class="rightbox"></div>

    <div class="lefttopblock" v-show="openvisible">
      <img src="../assets/images/ta/ta-hj-leftTitle01.png" />
      <div class="lefttop1_1">诚信严谨 团结一致 求真务实 创新发展 追求卓越</div>
    </div>

    <div class="leftmiddleblock" v-show="openvisible">
      <img src="../assets/images/ta/ta-hj-leftTitle02.png" />
      <div style="height: 124px">
        <table class="yuangong">
          <tr>
            <td style="border-right: 1px solid white">
              <div class="yg">
                <div class="num">{{ personInfo.toNum }}</div>
                <div class="title" style="text-align:center;">应到人数</div>
              </div>
            </td>
            <td style="border-right: 1px solid white">
              <div class="yg">
                <div class="num">{{ personInfo.realNum }}</div>
                <div class="title" style="text-align:center;">实到人数</div>
              </div>
            </td>
            <td>
              <div class="yg">
                <div class="num">{{ personInfo.realRate }}</div>
                <div class="title" style="text-align:center;">出勤率</div>
              </div>
            </td>
          </tr>
        </table>
      </div>
      <img src="../assets/images/ta/ta-hj-leftTitle03.png" />
      <div style="height: 164px; width: 80%; margin: 0 auto">
        <table>
          <tr>
            <td>
              <div class="ygimg">
                <img
                  src="../assets/images/ta/employee.png"
                  style="margin: 0 auto; padding-top: 4px"
                />
              </div>
            </td>
            <td>
              <div class="yginfo">
                <div>{{ employeeInfo.name }}</div>
                <div style="margin-top: 15px">工号:{{ employeeInfo.no }}</div>
                <div style="margin-top: 15px">工种:{{ employeeInfo.work }}</div>
              </div>
            </td>
          </tr>
        </table>
      </div>
    </div>

    <div class="leftdownblock" v-show="openvisible">
      <img src="../assets/images/ta/ta-hj-leftTitle04.png" />
      <div class="eventalertnum" id="eventalertnum"></div>
    </div>

    <div class="righttopblock" v-show="openvisible">
      <img src="../assets/images/ta/ta-hj-rightTitle01.png" />
      <div>
        焦煤主要用于高炉炼铁和用于铜、铅、锌、钛、锑、汞等有色金属的鼓风炉冶炼，起还原剂、发热剂和料柱骨架作用。
      </div>
      <div>
        为使高炉操作达到较好的技术经济指标，冶炼用焦煤（冶金焦）必须具有适当的化学性质和物理性质，包括冶炼过程中的热态性质。
      </div>
      <div>
        焦煤除大量用于炼铁和有色金属冶炼（冶金焦）外，还用于铸造、化工、电石和铁合金。
      </div>
    </div>

    <div class="rightdownblock" v-show="openvisible">
      <img src="../assets/images/ta/ta-hj-rightTitle02.png" />
      <div class="rightData">
        <ul>
          <li>
            <div style="width: 100%; height: 100%; text-align: left">
              <div
                style="
                  width: 44px;
                  height: 44px;
                  line-height: 44px;
                  float: left;
                "
              >
                <img
                  src="../assets/images/ta/ta-hj-rightTitle02Mwo.png"
                  style="vertical-align: middle"
                />
              </div>
              <div
                style="
                  float: left;
                  width: 170px;
                  text-align: right;
                  height: 44px;
                  line-height: 44px;
                "
              >
                <span class="rightnum">{{ powerusedNum.water }}</span>
              </div>
              <div style="float: left">
                <span class="righttt">总用水量</span>
              </div>
              <div><span class="rightunit">(立方米)</span></div>
            </div>
          </li>
          <li>
            <div style="width: 100%; height: 100%; text-align: left">
              <div
                style="
                  width: 44px;
                  height: 44px;
                  line-height: 44px;
                  float: left;
                "
              >
                <img
                  src="../assets/images/ta/ta-hj-rightTitle02Gas.png"
                  style="vertical-align: middle"
                />
              </div>
              <div
                style="
                  float: left;
                  width: 170px;
                  text-align: right;
                  height: 44px;
                  line-height: 44px;
                "
              >
                <span class="rightnum">{{ powerusedNum.gas }}</span>
              </div>
              <div style="float: left">
                <span class="righttt">总用气量</span>
              </div>
              <div><span class="rightunit">(立方米)</span></div>
            </div>
          </li>
          <li>
            <div style="width: 100%; height: 100%; text-align: left">
              <div
                style="
                  width: 44px;
                  height: 44px;
                  line-height: 44px;
                  float: left;
                "
              >
                <img
                  src="../assets/images/ta/ta-hj-rightTitle02Ele.png"
                  style="vertical-align: middle"
                />
              </div>
              <div
                style="
                  float: left;
                  width: 170px;
                  text-align: right;
                  height: 44px;
                  line-height: 44px;
                "
              >
                <span class="rightnum">{{ powerusedNum.eletric }}</span>
              </div>
              <div style="float: left">
                <span class="righttt">总用电量</span>
              </div>
              <div><span class="rightunit">(千瓦时)</span></div>
            </div>
          </li>
        </ul>
      </div>
    </div>

    <div class="lefttop" v-show="!openvisible">
      <img src="../assets/images/ta/neiye/ta-ny-leftTitleBg01.png" />
      <div class="lt_1">
        <img src="../assets/images/ta/neiye/p1.png" align="absmiddle" />
        <span class="lt_1_t">排放口名称:{{ pfkInfo.name }}</span>
      </div>
      <div class="lt_1" style="margin-top: 15px">
        <img src="../assets/images/ta/neiye/p2.png" align="absmiddle" />
        <span class="lt_1_t">排放口编号:{{ pfkInfo.no }}</span>
      </div>
    </div>
    <div class="leftdown" v-show="!openvisible">
      <img src="../assets/images/ta/neiye/ta-ny-leftTitleBg02.png" />
      <div class="down_con">
        <div class="down_t" style="height: 200px">
          <table style="margin: 0 auto; width: 100%; text-align: center">
            <tr>
              <td>
                <img
                  src="../assets/images/ta/neiye/ta-ny-leftTitle02eryanghualiu03.png"
                />
              </td>
              <td>
                <img
                  src="../assets/images/ta/neiye/ta-ny-leftTitle02keliwu03.png"
                />
              </td>
            </tr>
            <tr>
              <td>
                <span class="fwtitle">二氧化硫</span>
              </td>
              <td>
                <span class="fwtitle">颗粒物</span>
              </td>
            </tr>
            <tr>
              <td>
                <span class="fwvalue">&lt;</span>
                <span class="fwvalue">70</span
                ><span class="fwunit">mg/m^3</span>
              </td>
              <td>
                <span class="fwvalue">&lt;</span>
                <span class="fwvalue">30</span
                ><span class="fwunit">mg/m^3</span>
              </td>
            </tr>
          </table>
        </div>
        <div class="down_t" style="height: 240px; margin: 0 auto">
          <table
            style="
              margin: 0 auto;
              background: rgba(139, 213, 255, 0.15);
              width: 100%;
              text-align: center;
            "
          >
            <tr>
              <td>
                <img
                  src="../assets/images/ta/neiye/ta-ny-leftTitle02keliwu02.png"
                  class="icon"
                  align="absmiddle"
                />
              </td>
              <td>
                <span class="ptitle">颗粒物</span>
              </td>
              <td>
                <span class="pnum" style="color: #0ee79c">{{limitValue.klw}}</span>
              </td>
              <td>
                <span class="punit">mg/m^3</span>
              </td>
            </tr>
            <tr>
              <td>
                <img
                  src="../assets/images/ta/neiye/ta-ny-leftTitle02erynaghualiu02.png"
                  class="icon"
                  align="absmiddle"
                />
              </td>
              <td>
                <span class="ptitle">二氧化硫</span>
              </td>
              <td>
                <span class="pnum" style="color: #ff5c5f">{{limitValue.eyhl}}</span>
              </td>
              <td>
                <span class="punit">mg/m^3</span>
              </td>
            </tr>
            <tr>
              <td>
                <img
                  src="../assets/images/ta/neiye/ta-ny-leftTitle02liuliang.png"
                  class="icon"
                  align="absmiddle"
                />
              </td>
              <td>
                <span class="ptitle">流量</span>
              </td>
              <td>
                <span class="pnum" style="color: #0ee79c">{{limitValue.ll}}</span>
              </td>
              <td>
                <span class="punit">m^3/s</span>
              </td>
            </tr>
            <tr>
              <td>
                <img
                  src="../assets/images/ta/neiye/ta-ny-leftTitle02yanghanliang.png"
                  class="icon"
                  align="absmiddle"
                />
              </td>
              <td>
                <span class="ptitle">氧含量</span>
              </td>
              <td>
                <span class="pnum" style="color: #0ee79c">{{limitValue.yhl}}</span>
              </td>
              <td>
                <span class="punit">%</span>
              </td>
            </tr>
          </table>
        </div>
        <div class="down_t" style="height: 200px; margin: 0 auto">
          <table
            style="
              margin: 0 auto;
              width: 100%;
              text-align: center;
              margin-top: 20px;
            "
          >
            <tr>
              <td width="30%">
                <img
                  src="../assets/images/ta/neiye/ta-ny-leftTitle02green.png"
                  align="absmiddle"
                />
              </td>
              <td width="25%">
                <span class="green">绿色</span>
              </td>
              <td width="45%">
                <span class="sm">低于限值的80％</span>
              </td>
            </tr>
            <tr>
              <td>
                <img
                  src="../assets/images/ta/neiye/ta-ny-leftTitle02yellow.png"
                  align="absmiddle"
                />
              </td>
              <td>
                <span class="green">黄色</span>
              </td>
              <td>
                <span class="sm">限值的80-90％</span>
              </td>
            </tr>
            <tr>
              <td>
                <img
                  src="../assets/images/ta/neiye/ta-ny-leftTitle02orange.png"
                  align="absmiddle"
                />
              </td>
              <td>
                <span class="orange">橙色</span>
              </td>
              <td>
                <span class="sm">限值的90-100％</span>
              </td>
            </tr>
            <tr>
              <td>
                <img
                  src="../assets/images/ta/neiye/ta-ny-leftTitle02red.png"
                  align="absmiddle"
                />
              </td>
              <td>
                <span class="red">红色</span>
              </td>
              <td>
                <span class="sm">达到或超过限值</span>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
    <div class="righttop" v-show="!openvisible">
      <img src="../assets/images/ta/neiye/ta-ny-rightTitleBg01.png" />
      <div class="com_d">
        <span>{{ deviceInfo.cmpname }}</span>
      </div>
      <div class="com_d" style="background: rgba(139, 213, 255, 0.1)">
        <span>{{ deviceInfo.devicecate }}</span>
      </div>
      <div class="com_d">
        <span>{{ deviceInfo.factoryNo }}</span>
      </div>
      <div class="com_d" style="background: rgba(139, 213, 255, 0.1)">
        <span>{{ deviceInfo.manufacted }}</span>
      </div>
      <div class="com_d">
        <span>{{ deviceInfo.yunweicmp }}</span>
      </div>
    </div>
    <div class="rightdown" v-show="!openvisible">
      <img src="../assets/images/ta/neiye/ta-ny-rightTitleBg02.png" />
      <div class="com_d">
        <span>{{ hbDevice.cont1 }}</span>
      </div>
      <div class="com_d" style="background: rgba(139, 213, 255, 0.1)">
        <span>{{ hbDevice.cont2 }}</span>
      </div>
      <div class="com_d">
        <span>{{ hbDevice.cont2 }}</span>
      </div>
    </div>

    <div class="goback" @click="goback()" v-show="!openvisible">
      <img src="../assets/images/ta/neiye/goback.png" />
    </div>
    <!-- <button @click="goback()">44567895</button> -->
  </div>
</template>

<script>
import axios from "axios";
import { InitClientSocket, Mirror } from "kd-api-project/lib";
import { Poi } from "kd-api-project/lib";
import { Camera } from "kd-api-project/lib";
import _global from "../components/Global.vue";
import { Paho } from "../assets/js/mqttws31.min";

var error = [
  { code: 0, text: "连接成功" },
  { code: 1, text: "连接超时" },
  { code: 2, text: "订阅超时" },
  { code: 3, text: "取消订阅超时" },
  { code: 4, text: "Ping超时" },
  { code: 5, text: "内部错误" },
  { code: 6, text: "连接断开" },
  { code: 7, text: "连接失败" },
  { code: 8, text: "连接关闭" },
  { code: 9, text: "格式错误" },
  { code: 10, text: "浏览器不支持" },
  { code: 11, text: "无效状态" },
  { code: 12, text: "无效类型" },
  { code: 13, text: "无效参数" },
  { code: 14, text: "无效操作" },
  { code: 15, text: "无效数据" },
  { code: 16, text: "无效消息" },
  { code: 17, text: "格式错误" },
];

const echarts = require("echarts");

const waterPoints = [
  { poiName: "二分厂干熄焦", pos: { x: 5786, y: 170, z: 5348 } },
  { poiName: "二分厂烟囱", pos: { x: 5789, y: 208, z: 5513 } },
  { poiName: "二分厂出焦", pos: { x: 5792, y: 130, z: 5654 } },
  { poiName: "焚烧炉", pos: { x: 5716, y: 115, z: 5805 } },
  { poiName: "回用水池", pos: { x: 5745, y: 108, z: 5812 } },
  { poiName: "一分厂出焦", pos: { x: 5770, y: 125, z: 6070 } },
  { poiName: "一分厂装煤", pos: { x: 5782, y: 108, z: 6080 } },
  { poiName: "一分厂烟囱", pos: { x: 5776, y: 223, z: 6210 } },
  { poiName: "一分厂干熄焦", pos: { x: 5899, y: 120, z: 6267 } },
  { poiName: "二分厂装煤", pos: { x: 5815, y: 116, z: 5654 } },
];

import waterImg from "../assets/images/ta/tc-tab.png";

//设置连接服务器的参数
var hostname = "127.0.0.1",
  port = 28883,
  clientId =
    "client-" +
    Number(Math.random().toString().substr(2, 5) + Date.now()).toString(36),
  timeout = 30,
  keepAlive = 60,
  cleanSession = true,
  ssl = false,
  topic = "AirPollutantCollected-Data",
  reConnectTimeout = 5;

export default {
  data() {
    return {
      openvisible: true,
      zztdataoption: {
        //backgroundColor: "#111c4e",
        color: ["#3398DB"],
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "line",
            lineStyle: {
              opacity: 0,
            },
          },
          // formatter: function (prams) {
          //   return "办理数：" + prams[0].data;
          // },
        },
        grid: {
          left: "0%",
          right: "0%",
          bottom: "5%",
          top: "7%",
          height: "85%",
          containLabel: true,
          z: 22,
        },
        xAxis: [
          {
            type: "category",
            gridIndex: 0,
            data: [
              "01",
              "02",
              "03",
              "04",
              "05",
              "06",
              "07",
              "08",
              "09",
              "10",
              "11",
              "12",
            ],
            axisTick: {
              alignWithLabel: true,
            },
            axisLine: {
              lineStyle: {
                color: "#0c3b71",
              },
            },
            axisLabel: {
              show: true,
              color: "rgb(170,170,170)",
              fontSize: 10,
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            gridIndex: 0,
            splitLine: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            axisLine: {
              lineStyle: {
                color: "#0c3b71",
              },
            },
            axisLabel: {
              color: "rgb(170,170,170)",
              formatter: "{value}",
            },
          },
          {
            type: "value",
            gridIndex: 0,
            splitNumber: 12,
            splitLine: {
              show: false,
            },
            axisLine: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            axisLabel: {
              show: false,
            },
            splitArea: {
              show: true,
              areaStyle: {
                color: ["rgba(250,250,250,0.0)", "rgba(250,250,250,0.05)"],
              },
            },
          },
        ],
        series: [
          {
            name: "事件",
            type: "bar",
            barWidth: "30%",
            xAxisIndex: 0,
            yAxisIndex: 0,
            label: {
              normal: {
                //show: true,
                position: "top",
                textStyle: {
                  color: "#ffc72b",
                  fontSize: 20,
                },
              },
            },
            itemStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: "#00feff",
                  },
                  {
                    offset: 0.5,
                    color: "#027eff",
                  },
                  {
                    offset: 1,
                    color: "#0286ff",
                  },
                ]),
              },
            },
            data: [5, 10, 8, 15, 2, 10, 16, 5, 8, 14, 6, 18],
            zlevel: 11,
          },
          {
            name: "事件",
            type: "bar",
            barWidth: "50%",
            xAxisIndex: 0,
            yAxisIndex: 1,
            barGap: "-135%",
            data: [20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20],
            itemStyle: {
              normal: {
                color: "rgba(255,255,255,0.1)",
              },
            },
            zlevel: 9,
          },
        ],
      },
      sysTimes: {
        week: "",
        date: "",
        time: "",
      },
      personInfo: {
        toNum: 100,
        realNum: 99,
        realRate: "98%",
      },
      employeeInfo: {
        name: "尹诚毅",
        no: "321328",
        work: "技术人员",
      },
      powerusedNum: {
        water: _global.ThousandSplit(258748),
        gas: _global.ThousandSplit(298025),
        eletric: _global.ThousandSplit(280529),
      },
      pfkInfo: {
        name: "一分厂装煤",
        no: "DA015",
      },
      limitValue:{
        klw:30,
        eyhl:70,
        ll:30,
        yhl:30
      },
      deviceInfo: {
        cmpname: "铜陵蓝光电子科技有限公司",
        devicecate: "设备型号:TLG-300",
        factoryNo: "出厂编号：YQ210401033",
        manufacted: "生产日期:2022.1.19",
        yunweicmp: "运维单位:利源",
      },
      hbDevice: {
        cont1: "地面除尘站",
        cont2: "治理工艺:半干法钙基脱硫+除尘",
        cont3: "运营状态:正常",
      },
    };
  },
  methods: {
    goback() {
      this.openvisible = true;
      // 添加分镜
      // Mirror.addMirror('返回').then(() => {
      //     // 添加成功
      // }).catch((err) => {
      //     // 添加失败，err为失败描述
      // })

      //alert(556)
      // 获取分镜列表
      // Mirror.getMirrorData().then((res) => {
      //   console.log(res)
      //     // 获取成功
      // }).catch((err) => {
      //     // 获取失败
      // })
      // 分镜预览
      Mirror.setMirrotByShotName({
        name: "返回", //让unity给分镜头名称
        duration: 2,
      })
        .then(() => {
          // 预览成功
        })
        .catch((err) => {
          // 预览失败，err为失败描述
        });
    },
    websocketConn() {
      var client = new Paho.MQTT.Client(hostname, port, clientId);
      //注册连接断开处理事件
      client.onConnectionLost = onConnectionLost;
      //注册消息接收处理事件
      client.onMessageArrived = onMessageArrived;

      var options = {
        invocationContext: {
          host: hostname,
          port: port,
          path: client.path,
          clientId: clientId,
        },
        timeout: timeout,
        keepAliveInterval: keepAlive,
        cleanSession: cleanSession,
        useSSL: ssl,
        onSuccess: onConnect,
        onFailure: function (e) {
          if (typeof error[e.errorCode] == "undefined") {
            console.log("未知错误");
          } else {
            console.log(error[e.errorCode].text);
          }
        },
      };
      //连接服务器
      client.connect(options);

      //重新连接服务器
      function reConnect() {
        window.reConnecter = window.setInterval(function () {
          clientId =
            "client-" +
            Number(Math.random().toString().substr(2, 5) + Date.now()).toString(
              36
            );
          options = null;
          client = null;
          client = new Paho.MQTT.Client(hostname, port, clientId);
          options = {
            invocationContext: {
              host: hostname,
              port: port,
              path: client.path,
              clientId: clientId,
            },
            timeout: timeout,
            keepAliveInterval: keepAlive,
            cleanSession: cleanSession,
            useSSL: ssl,
            onSuccess: onConnect,
          };
          //注册连接断开处理事件
          client.onConnectionLost = onConnectionLost;
          //注册消息接收处理事件
          client.onMessageArrived = onMessageArrived;
          //连接服务器
          client.connect(options);
        }, reConnectTimeout * 1000);
      }

      //连接成功处理事件
      function onConnect() {
        //console.log("onConnected");
        window.clearInterval(window.reConnecter);
        client.subscribe(topic);
      }
      //断开连接处理事件
      function onConnectionLost(e) {
        if (typeof error[e.errorCode] == "undefined") {
          console.log("未知错误");
        } else {
          console.log(error[e.errorCode].text);
        }

        window.clearInterval(window.reConnecter);
        reConnect();
      }
      //接收数据处理事件
      function onMessageArrived(mes) {
        // {"device_name":"二分厂干熄焦","device_code":"DA028","last_time":"2022-02-16 09:19:00","items":[{"name":"标态流量","field":"B02-Rtd","value":"26.19"},{"name":"烟气温度","field":"S03-Rtd","value":"26.39"},{"name":"烟气压力","field":"S08-Rtd","value":"-0.12"},{"name":"烟气流速","field":"S02-Rtd","value":"6.58"},{"name":"烟气湿度","field":"S05-Rtd","value":"2.9"},{"name":"氧气含量","field":"S01-Rtd","value":"18.42"},{"name":"烟尘","field":"01-Rtd","value":"18.42"},{"name":"二氧化硫","field":"02-Rtd","value":"26.19"}]}
        console.log("收到消息:" + mes);
        var message = JSON.parse(mes);

        //循环解析
        for (var i = 0; i < message.length; i++) {
          if (message[i].device_name === this.pfkInfo.name) {
            //this.pfkInfo.name = message[i].device_name;
            this.pfkInfo.no = message[i].device_code;
            if (message[i].item.length > 0) {
              for (var a = 0; a < message[i].item.length; a++) {
                switch (message[i].item[a]) {
                  case "烟气温度":
                    var title = message[i].item[a].name;
                    var field = message[i].item[a].field;
                    var value = message[i].item[a].value;
                    break;
                  case "烟气温度":
                    var title = message[i].item[a].name;
                    var field = message[i].item[a].field;
                    var value = message[i].item[a].value;
                    break;
                }
              }
            }
          }
        }
      }
    },
    go() {
      //this.$router.push({ name: "cont1", params: { name: "一分厂装煤" } });
    },
    showzzt() {
      let charts = echarts.init(document.getElementById("eventalertnum"));
      charts.setOption(this.zztdataoption);
    },
    showTime() {
      setInterval(() => {
        var dt = _global.getCurrentTime();
        this.sysTimes.week = dt.week;
        this.sysTimes.time = dt.time;
        this.sysTimes.date = dt.date;
      }, 1000);
    },
    showtoNum() {
      var toNum = 100.0;
      var realNum = Math.floor(Math.random() * 50) + 50;
      var realRate = realNum + "%"; //(realNum / toNum).toFixed(2) * 100 + "%";
      this.personInfo.toNum = toNum;
      this.personInfo.realNum = realNum;
      this.personInfo.realRate = realRate;
    },
    showCost() {
      var water = Math.floor(Math.random() * 100000) + 200000;
      var gas = Math.floor(Math.random() * 100000) + 200000;
      var ele = Math.floor(Math.random() * 100000) + 200000;
      this.powerusedNum.water = _global.ThousandSplit(water);
      this.powerusedNum.gas = _global.ThousandSplit(gas);
      this.powerusedNum.eletric = _global.ThousandSplit(ele);
    },
    getDots() {
      //加载场景
      console.log(InitClientSocket, "InitClientSocket");
      InitClientSocket.init(
        "fullDis",
        "ws://58.213.192.217:40968/2",
        "1920*1080"
      ).then((res) => {
        // console.log(res,'fffffffffffffffffffff');
        //加载水滴
        setTimeout(() => {
          this.loadAllWaterPois();
        }, 3000);
      });
    },

    loadAllWaterPois() {
      Poi.createPoiToVector(waterPoints).then((res) => {
        console.log(res, "aaaaaaaaaa");
        // 创建poi点之后为每个水滴创建一个ui
        // 再获取所有POI点
        Poi.getAllPoiNames().then((rev) => {
          console.log(rev.data);
          // 获取成功,使用所有的点坐标生成图片
          this.createSingleUI(rev.data);
          // Ui跟随
          Poi.getPoiUi
            .init({
              poiNameList: rev.data,
              renderClassName: "pointButton",
              videoPlayerDom: "fullDis",
            })
            .then((res) => {
              // 成功
            });
        });
      });
    },
    createSingleUI(pointList) {
      console.log(pointList, "pointList pointList");
      const homes = document.getElementById("home");
      waterPoints.forEach((t) => {
        //console.log(t);
        let poiImg = document.createElement("img");
        poiImg.className = "pointButton";
        poiImg.style.width = "50px";
        poiImg.style.height = "175px";
        poiImg.style.zIndex = "10";
        poiImg.src = waterImg;
        poiImg.setAttribute("PoiName", t.poiName);
        poiImg.onclick = () => {
          //console.log(t.poiName);
          // 当点击时候，进入内页
          //this.$router.push({ name: "cont1", params: { name: t.poiName } });
          this.openvisible = false;
          this.pfkInfo.name = t.poiName;
          switch(t.poiName)
          {
            case '一分厂装煤':
              this.pfkInfo.no='DA015';
              this.limitValue.yhl=55;
              this.limitValue.klw=42;
              this.limitValue.ll=31;
              this.limitValue.eyhl=80;
              break;
            case '二分厂装煤':
              this.pfkInfo.no='DA024';
              this.limitValue.yhl=58;
              this.limitValue.klw=35;
              this.limitValue.ll=23;
              this.limitValue.eyhl=81;
              break;
            case '一分厂干熄焦':
              this.pfkInfo.no='DA023';
              this.limitValue.yhl=50;
              this.limitValue.klw=40;
              this.limitValue.ll=30;
              this.limitValue.eyhl=69;
              break;
            case '一分厂烟囱':
              this.pfkInfo.no='DA027';
              this.limitValue.yhl=20;
              this.limitValue.klw=44;
              this.limitValue.ll=30;
              this.limitValue.eyhl=75;
              break;
            case '一分厂出焦':
              this.pfkInfo.no='DA003';
              this.limitValue.yhl=30;
              this.limitValue.klw=30;
              this.limitValue.ll=10;
              this.limitValue.eyhl=80;
              break;
            case '回用水池':
              this.pfkInfo.no='DA004';
              this.limitValue.yhl=45;
              this.limitValue.klw=20;
              this.limitValue.ll=10;
              this.limitValue.eyhl=90;
              break;
            case '焚烧炉':
              this.pfkInfo.no='DA005';
              this.limitValue.yhl=41;
              this.limitValue.klw=20;
              this.limitValue.ll=32;
              this.limitValue.eyhl=80;
              break;
            case '二分厂出焦':
              this.pfkInfo.no='DA028';
              this.limitValue.yhl=32;
              this.limitValue.klw=32;
              this.limitValue.ll=30;
              this.limitValue.eyhl=88;
              break;
            case '二分厂烟囱':
              this.pfkInfo.no='DA025';
              this.limitValue.yhl=20;
              this.limitValue.klw=20;
              this.limitValue.ll=40;
              this.limitValue.eyhl=95;
              break;
            case '二分厂干熄焦':
              this.pfkInfo.no='DW002';
              this.limitValue.yhl=10;
              this.limitValue.klw=40;
              this.limitValue.ll=40;
              this.limitValue.eyhl=60;
              break;
          }
          //alert(t.poiName);
          // 添加分镜
          Mirror.addMirror("返回")
            .then(() => {
              // 添加成功
            })
            .catch((err) => {
              // 添加失败，err为失败描述
            });
          // 聚焦poi
          Poi.focusOnPoi(t.poiName)
            .then((res) => {
              console.log(res);
              // 聚焦成功
            })
            .catch((err) => {
              // 聚焦失败，err为失败描述
            });
        };
        homes?.appendChild(poiImg);
      });

      //this.sendAllData();
    },
    sendAllData() {
      const list = document.getElementsByClassName("pointButton");
      if (list != null && list.length > 0) {
        const POIs = [];
        for (let i = 0; i < list.length; i++) {
          const poiname = list[i].getAttribute("PoiName");
          POIs.push(poiname ? poiname : "");
        }
        if (poiNamesData.value.length) {
          this.getPoisScreem(POIs);
        }
      }
      setTimeout(this.sendAllData, 1000);
    },
    getPoisScreem(pos) {
      Poi.getPoisScreemPos(pos).then((res) => {
        setPoiNamesScreenPos(JSON.stringify(res.data));
      });
    },
    setPoiNamesScreenPos(data) {
      const Obj = JSON.parse(data);
      const eleList = document.getElementsByClassName("PointButton");
      if (Obj.length != eleList.length) {
        return;
      }
      for (let i = 0; i < Obj.length; i++) {
        const v = Obj[i];
        if (v.poiName != eleList[i].getAttribute("PoiName")) {
          return;
        }
        this.setScreenPosByele(eleList[i], v.x, v.y);
      }
    },
    setScreenPosByele(ele, x, y) {
      let scale = 0;
      ele.style.display = "";
      // unity基座的宽高
      const vMouseX = document.getElementById("home").videoWidth;
      const vMouseY = document.getElementById("home").videoHeight;
      // 视频的宽高
      const remoteVideo = document.getElementById("home");
      const remoteVideoWidth = remoteVideo.clientWidth;
      const remoteVideoHeight = remoteVideo.clientHeight;
      console.log(remoteVideoWidth);
      // UI元素的宽高
      const eleWidth = parseInt(ele.clientWidth);
      const eleHeight = parseInt(ele.clientHeight);

      if (vMouseX / vMouseY > remoteVideoWidth / remoteVideoHeight) {
        scale = remoteVideoWidth / vMouseX;
        ele.style.left = x * scale - eleWidth / 2 + "px";
        ele.style.top =
          (vMouseY - y) * scale +
          (remoteVideoHeight - vMouseY * scale) / 2 -
          eleHeight +
          "px";
      } else {
        scale = remoteVideoHeight / vMouseY;
        ele.style.left =
          x * scale +
          (remoteVideoWidth - vMouseX * scale) / 2 -
          eleWidth / 2 +
          "px";
        ele.style.top = (vMouseY - y) * scale - eleHeight + "px";
      }

      const topoff = parseInt(ele.style.top) - 3;
      const btmoff = remoteVideoHeight - topoff - eleHeight - 3;
      var left = parseInt(ele.style.left) - 3;
      var right = remoteVideoWidth - parseInt(ele.style.left) - eleWidth - 3;
      if (
        topoff < (remoteVideoHeight - vMouseY * scale) / 2 ||
        btmoff < (remoteVideoHeight - vMouseY * scale) / 2 ||
        left < (remoteVideoWidth - vMouseX * scale) / 2 ||
        right < (remoteVideoWidth - vMouseX * scale) / 2
      ) {
        ele.style.display = "none";
      } else {
        ele.style.display = "";
      }
    },
    cameraControl() {
      Camera.modifySetCameraProperty(180, 1, 100)
        .then(() => {
          // 修改成功
        })
        .catch((err) => {
          // 修改失败，err为失败描述
        });

      // 相机的移动限制
      Camera.modifySetCameraMoveLimit(10, 10, 100, 1000)
        .then(() => {
          // 修改成功
        })
        .catch((err) => {
          // 修改失败，err为失败描述
        });
    },
  },
  mounted() {
    this.showzzt();
    this.showTime();
    this.$nextTick(() => {
      this.getDots();
    });
    this.showtoNum();
    this.showCost();
    this.websocketConn();
    //this.cameraControl();
  },
};
</script>

<style lang="scss" scoped>
.full {
  position: relative;
  margin: 0;
  padding: 0;
  width: 1920px;
  height: 1080px;
  overflow: none;
  overflow-x: hidden;
  overflow-y:hidden;
  z-index: 1;
}

.fullbg_top {
  position: absolute;
  top: 0;
  left: 0;
  width: 1920px;
  height: 142px;
  background: url(../assets/images/ta/ta-Bg1.png) no-repeat;
  opacity: 0.1;
  overflow: hidden;
}

.fullbg_left {
  position: absolute;
  top: 142px;
  left: 0px;
  width: 418px;
  height: 938px;
  background: url(../assets/images/ta/ta-Bg2.png) no-repeat;
  opacity: 0.1;
  overflow: hidden;
}

.fullbg_right {
  position: absolute;
  top: 142px;
  left: 1502px;
  width: 418px;
  height: 938px;
  background: url(../assets/images/ta/ta-Bg2.png) no-repeat;
  opacity: 0.1;
  overflow: hidden;
}

.vdo {
  position: relative;
  margin: 0;
  padding: 0;
  overflow: hidden;
  overflow-x: hidden;
  overflow-y: hidden;
}

::-webkit-scrollbar {
width: 0px;
}

::-webkit-scrollbar-track {
background-color: none;
}

::-webkit-scrollbar-thumb {
background-color: none;
}

::-webkit-scrollbar-thumb:hover {
background-color: none;
}

::-webkit-scrollbar-thumb:active {
background-color: none;
}

.headerbg {
  position: absolute;
  top: 0px;
  left: 0px;
  width: 1920px;
  height: 154px;
  background: url(../assets/images/ta/ta-topShadow.png) no-repeat;
  //z-index: 7;
}

.headerbar {
  width: 1970px;
  height: 133px;
  position: absolute;
  //top: 4px;
  left: -20px;
  background: url(../assets/images/ta/ta-topMenu.png) no-repeat;
  z-index: 3;
}

.leftbar {
  z-index: 3;
  position: absolute;
  top: 133px;
  left: 0px;
  width: 17px;
  height: 918px;
  background: url(../assets/images/ta/ta-leftBorder.png) no-repeat;
}

.rightbar {
  position: absolute;
  z-index: 3;
  top: 133px;
  right: 0px;
  width: 17px;
  height: 918px;
  background: url(../assets/images/ta/ta-rightBorder.png) no-repeat;
}

.leftbox {
  //z-index: 7;
  position: absolute;
  top: 0px;
  left: 0px;
  width: 463px;
  height: 1080px;
  background: url(../assets/images/ta/ta-leftShadow.png) no-repeat;
}

.rightbox {
  //z-index: 7;
  position: absolute;
  top: 0px;
  right: 0px;
  width: 463px;
  height: 1080px;
  background: url(../assets/images/ta/ta-rightShadow.png) no-repeat;
}

.menu {
  position: absolute;
  top: 0px;
  left: 530px;
  top: 47px;
  //z-index: 7;
}

.menu li {
  display: inline-block;
  margin-left: 20px;
  cursor: pointer;
}

.ts {
  font-size: 26px;
  font-family: YouSheBiaoTiHei;
  color: white;
  line-height: 34px;
  background-image: url(../assets/images/ta/ta-topButton-hover.png);
  background-repeat: no-repeat;
  padding-left: 10px;
}

.menu li span {
  font-size: 26px;
  font-family: YouSheBiaoTiHei;
  color: rgba(74, 81, 86, 0.8);
  line-height: 34px;
  background: linear-gradient(
    180deg,
    #02fafa 0%,
    #ffffff 53%,
    rgba(255, 255, 255, 0.94) 68%,
    rgba(2, 250, 250, 0.8) 100%
  );
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.weather {
  position: absolute;
  left: 1721px;
  top: 18px;
}

.time {
  width: 96px;
  height: 34px;
  font-size: 34px;
  font-family: SourceHanSansCN-Medium, SourceHanSansCN;
  font-weight: 500;
  color: #eff9ff;
  line-height: 34px;
  letter-spacing: 1px;
}

.week {
  width: 45px;
  height: 15px;
  font-size: 15px;
  font-family: SourceHanSansCN-Regular, SourceHanSansCN;
  font-weight: 400;
  color: #eff9ff;
  line-height: 22px;
}

.date {
  margin-top: 5px;
  width: 76px;
  height: 15px;
  font-size: 15px;
  font-family: SourceHanSansCN-Medium, SourceHanSansCN;
  font-weight: 500;
  color: #eff9ff;
  line-height: 22px;
}

.temp {
  width: 25px;
  height: 16px;
  font-size: 16px;
  font-family: SourceHanSansCN-Medium, SourceHanSansCN;
  font-weight: 500;
  color: #eff9ff;
  line-height: 24px;
}

.lefttopblock {
  //z-index: 7;
  position: absolute;
  left: 41px;
  top: 133px;
  width: 379px;
  height: 218px;
  background: url(../assets/images/ta/ta-hj-leftTitleBg01.png) no-repeat;
}

.lefttop1_1 {
  position: absolute;
  left: 75px;
  top: 54px;
  width: 226px;
  height: 117px;
  font-size: 26px;
  font-family: SourceHanSansCN-Medium, SourceHanSansCN;
  font-weight: 500;
  color: rgba(239, 249, 255, 0.9);
  line-height: 39px;
}

.leftmiddleblock {
  //z-index: 7;
  position: absolute;
  left: 41px;
  top: 381px;
  width: 376px;
  height: 372px;
  background: url(../assets/images/ta/ta-hj-leftTitleBg02.png) no-repeat;
}

.yuangong {
  width: 90%;
  text-align: center;
  margin: 0 auto;
}

.yg {
  height: 80px;
}

.num {
  font-size: 40px;
  font-family: YouSheBiaoTiHei;
  color: #429dff;
}

.pnum {
  font-size: 40px;
  font-family: YouSheBiaoTiHei;
  color: #429dff;
  float:left;
  margin-left:-20px;
}

.title {
  font-size: 20px;
  font-family: SourceHanSansCN-Regular, SourceHanSansCN;
  font-weight: 40;
  color: #eff9ff;
  // background:green;
  margin-top: -190px;
  margin-left:20px;
  text-align:center;
  float:left;
}

.ptitle {
  font-size: 20px;
  font-family: SourceHanSansCN-Regular, SourceHanSansCN;
  font-weight: 40;
  color: #eff9ff;
  // background:green;
  //margin-left:10px;
  float:left;
}

.ygimg {
  width: 94px;
  height: 124px;
  background: green;
  background: url(../assets/images/ta/ta-hj-leftTitle03pinBg.png) no-repeat;
  text-align: center;
}

.yginfo {
  font-size: 20px;
  font-family: SourceHanSansCN-Regular, SourceHanSansCN;
  font-weight: 400;
  color: #eff9ff;
  line-height: 30px;
  margin-left: 20px;
}

.leftdownblock {
  //z-index: 7;
  position: absolute;
  left: 41px;
  top: 786px;
  width: 376px;
  height: 240px;
  background: url(../assets/images/ta/ta-hj-leftTitleBg03.png) no-repeat;
}

.eventalertnum {
  width: 90%;
  height: 150px;
  margin: 0 auto;
  margin-top: 10px;
}

.righttopblock {
  //z-index: 7;
  position: absolute;
  left: 1500px;
  top: 133px;
  width: 376px;
  height: 620px;
  background: url(../assets/images/ta/ta-hj-rightTitleBg01.png) no-repeat;
  margin: 0 auto;
}

.righttopblock div {
  margin: 0 auto;
  margin-top: 20px;
  width: 288px;
  font-size: 22px;
  font-family: SourceHanSansCN-Regular, SourceHanSansCN;
  font-weight: 400;
  color: rgba(239, 249, 255, 0.9);
  line-height: 34px;
  letter-spacing: 0.01em;
}

.rightdownblock {
  //z-index: 7;
  position: absolute;
  left: 1500px;
  top: 788px;
  width: 376px;
  height: 240px;
  background: url(../assets/images/ta/ta-hj-rightTitleBg02.png) no-repeat;
}

.rightData {
  width: 100%;
  margin: 0 auto;
  margin-top: 20px;
  //background:red;
}

.rightData ul li {
  display: block;
  list-style-type: none;
  height: 44px;
  line-height: 44px;
  margin-left: -20px;
  margin-top: 5px;
}

.rightnum {
  font-size: 36px;
  font-family: YouSheBiaoTiHei;
  color: #429dff;
  line-height: 44px;
  text-align: right;
}

.righttt {
  margin-left: 10px;
  height: 16px;
  font-size: 16px;
  font-family: SourceHanSansCN-Regular, SourceHanSansCN;
  font-weight: 40;
  color: #c3e8ff;
  line-height: 34px;
}

.rightunit {
  margin-left: 10px;
  font-size: 10px;
  font-family: SourceHanSansCN-Regular, SourceHanSansCN;
  font-weight: 40;
  color: #c3e8ff;
  height: 30px;
  line-height: 30px;
}

////////////////////////@at-root

.lefttop {
  position: absolute;
  left: 41px;
  top: 133px;
  width: 376px;
  height: 168px;
  background: url(../assets/images/ta/neiye/ta-ny-leftTitleBg01_1.png) no-repeat;
  //z-index: 3;
}

.lt_1 {
  width: 80%;
  margin: 0 auto;
}

.lt_1_t {
  margin-left: 10px;
  width: 220px;
  height: 20px;
  font-size: 20px;
  font-family: SourceHanSansCN-Regular, SourceHanSansCN;
  font-weight: 400;
  color: rgba(239, 249, 255, 0.9);
  line-height: 30px;
}

.leftdown {
  position: absolute;
  left: 41px;
  top: 333px;
  width: 376px;
  height: 695px;
  background: url(../assets/images/ta/neiye/ta-ny-leftTitleBg02_1.png) no-repeat;
  //z-index: 3;
}

.down_con {
  width: 90%;
  margin: 0 auto;
}

.righttop {
  position: absolute;
  left: 1500px;
  top: 133px;
  width: 376px;
  height: 362px;
  background: url(../assets/images/ta/neiye/ta-ny-rightTitleBg01_1.png)
    no-repeat;

  //z-index: 3;
}

.com_d {
  width: 100%;
  margin: 0 auto;
  height: 60px;
  font-size: 20px;
  font-family: SourceHanSansCN-Regular, SourceHanSansCN;
  font-weight: 400;
  color: rgba(239, 249, 255, 0.9);
  line-height: 60px;
}

.com_d span {
  margin-left: 30px;
  line-height: 60px;
}

.goback {
  position: absolute;
  left: 864px;
  top: 992px;
  width: 192px;
  height: 56px;
  z-index: 10;
  //border: 1px solid red;
}

.rightdown {
  position: absolute;
  left: 1500px;
  top: 526px;
  width: 376px;
  height: 248px;
  background: url(../assets/images/ta/neiye/ta-ny-rightTitleBg02_1.png)
    no-repeat;
  //z-index: 3;
}

.green {
  width: 47px;
  height: 24px;
  font-size: 24px;
  font-family: PangMenZhengDao;
  color: #0ee79c;
  line-height: 27px;
  font-weight: 100;
}

.yellow {
  width: 45px;
  height: 24px;
  font-size: 24px;
  font-family: PangMenZhengDao;
  color: #ffc100;
  line-height: 27px;
  font-weight: 100;
}

.orange {
  width: 45px;
  height: 24px;
  font-size: 24px;
  font-family: PangMenZhengDao;
  color: #ff7a27;
  line-height: 27px;
  font-weight: 100;
}

.red {
  width: 47px;
  height: 24px;
  font-size: 24px;
  font-family: PangMenZhengDao;
  color: #ff4d4d;
  line-height: 27px;
  font-weight: 100;
}

.sm {
  width: 128px;
  height: 18px;
  font-size: 18px;
  font-family: SourceHanSansCN-Regular, SourceHanSansCN;
  font-weight: 400;
  color: #c3e8ff;
  line-height: 27px;
}

.fwtitle {
  width: 111px;
  height: 39px;
  font-size: 30px;
  font-family: YouSheBiaoTiHei;
  font-weight: 100;
  color: #eff9ff;
  opacity: 1;
  line-height: 39px;
  text-shadow: 0px 0px 6px rgba(255, 255, 255, 0.1);
}

.fwvalue {
  font-weight: 100;
  width: 66px;
  height: 39px;
  font-size: 30px;
  font-family: YouSheBiaoTiHei;
  color: #429dff;
  line-height: 39px;
}

.fwunit {
  width: 64px;
  height: 16px;
  font-size: 16px;
  font-family: SourceHanSansCN-Medium, SourceHanSansCN;
  font-weight: 500;
  color: #eff9ff;
  line-height: 16px;
}


.punit {
  width: 60px;
  height: 20px;
  font-size: 20px;
  font-family: SourceHanSansCN-Medium, SourceHanSansCN;
  font-weight: 500;
  color: #eff9ff;
  line-height: 30px;
  text-align: left;
  float:left;
}
</style>